import React, { useState } from 'react';
import { VcField } from './vehicle-form-fields';

const CONTAINER_KEYS = [
  'VCASCA_01',
  'VCASCA_02',
  'VCASCA_03',
  'VCASCA_04',
  'VCASCA_05',
  'VCASCA_06',
  'VCASCA_07',
  'VCASCA_08',
  'VCASCA_09',
  'VCASCA_10',
];

const numberFormatter = new Intl.NumberFormat('fr-FR');

export default function VehicleContainersStep({ vehicleData, setVehicleData }) {
  const isCiterneCompartimentee =
    vehicleData.LIBTYP === 'Citerne compartimentée';

  // Nombre de compartiments affichés (citerne compartimentée)
  const [visibleContainersCount, setVisibleContainersCount] = useState(
    Math.max(1, CONTAINER_KEYS.filter((key) => vehicleData[key]).length)
  );

  const handleChange = (field, value) => {
    setVehicleData({ ...vehicleData, [field]: value });
  };

  const handleClearContainer = (field) => {
    setVehicleData({ ...vehicleData, [field]: '' });
  };

  const filledContainersCount = CONTAINER_KEYS.filter(
    (key) => vehicleData[key]
  ).length;
  const totalCapacity = CONTAINER_KEYS.reduce(
    (sum, key) => sum + (parseFloat(vehicleData[key]) || 0),
    0
  );

  if (isCiterneCompartimentee) {
    return (
      <div className="vd vc-step">
        <section className="vd-section">
          <div className="vd-section__head">
            <div>
              <h3 className="vd-section__title">Compartiments de la citerne</h3>
              <p className="vd-section__description">
                Une ligne par cuve. La capacité totale du véhicule est la somme
                des compartiments.
              </p>
            </div>
            {visibleContainersCount < CONTAINER_KEYS.length && (
              <button
                type="button"
                className="vd-link"
                onClick={() =>
                  setVisibleContainersCount(visibleContainersCount + 1)
                }
              >
                + Ajouter un compartiment
              </button>
            )}
          </div>

          <div className="vd-table">
            <div className="vd-table__row vd-table__row--head">
              <span className="vd-col--name">Compartiment</span>
              <span className="vd-col--capacity">Capacité</span>
              <span className="vd-col--remove" />
            </div>
            {CONTAINER_KEYS.slice(0, visibleContainersCount).map(
              (key, index) => (
                <div key={key} className="vd-table__row">
                  <span className="vd-col--name">
                    Compartiment {index + 1}
                    {index === 0 && <span className="vc-required">requis</span>}
                  </span>
                  <span className="vd-input-wrap vd-col--capacity">
                    <input
                      className="vd-input"
                      type="number"
                      min="0"
                      value={vehicleData[key]}
                      onChange={(e) => handleChange(key, e.target.value)}
                      placeholder="1500"
                      aria-label={`Capacité du compartiment ${index + 1}`}
                    />
                    <span className="vd-input-wrap__suffix">kg</span>
                  </span>
                  {index > 0 ? (
                    <button
                      type="button"
                      className="vd-remove vd-col--remove"
                      onClick={() => handleClearContainer(key)}
                      title="Vider ce compartiment"
                    >
                      ✕
                    </button>
                  ) : (
                    <span className="vd-col--remove" />
                  )}
                </div>
              )
            )}
          </div>

          <div className="vc-total">
            <span>
              {filledContainersCount} compartiment
              {filledContainersCount > 1 ? 's' : ''} renseigné
              {filledContainersCount > 1 ? 's' : ''}
            </span>
            <span className="vc-total__value">
              Capacité totale : {numberFormatter.format(totalCapacity)} kg
            </span>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="vd vc-step">
      <section className="vd-section">
        <div className="vd-section__head">
          <div>
            <h3 className="vd-section__title">Capacité du véhicule</h3>
            <p className="vd-section__description">
              Utilisée par l&apos;optimisation pour ne jamais surcharger le
              véhicule.
              {vehicleData.LIBTYP &&
                ` Un véhicule « ${vehicleData.LIBTYP} » n'a qu'une capacité totale.`}
            </p>
          </div>
        </div>
        <div className="vd-grid">
          <VcField label="Capacité totale" required suffix="t">
            <input
              className="vd-input"
              type="number"
              min="0"
              step="0.1"
              value={vehicleData.VCASCA_01}
              onChange={(e) => handleChange('VCASCA_01', e.target.value)}
              placeholder="25"
            />
          </VcField>
        </div>
      </section>
    </div>
  );
}
